import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const TestimonialsPage = () => {
  const testimonials = [
    {
      id: 'client-a',
      name: 'Client A',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/9283fbe299b272da57d11e1aa4fa7198.png',
      summary: '3+ months sobriety milestone',
    },
    {
      id: 'client-b',
      name: 'Client B',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/beab011d22fa7a891c8a702296146923.png',
      summary: 'Coaching experience and commitment message',
    },
    {
      id: 'client-c',
      name: 'Client C',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/7b4914e47e3339416dddaf200dd23efb.png',
      summary: '10+ years addiction recovery journey',
    },
    {
      id: 'client-d',
      name: 'Client D',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/6bbcf0efd4b6331dc336419197e346df.png',
      summary: 'Addictive behavior patterns and 2 years sobriety',
    },
    {
      id: 'client-e',
      name: 'Client E',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/e6c2daca996cbcaa13de8e8f8bb510fd.png',
      summary: 'Multiple relapses per day to 2+ years sobriety',
    },
    {
      id: 'client-f',
      name: 'Client F',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/e54a605fbb4fb1ec32ab51973afae559.png',
      summary: 'Surprised by interpersonal support and coaching effectiveness',
    },
    {
      id: 'client-g',
      name: 'Client G',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/9ec23291b2134301e08f76c2963046e3.png',
      summary: 'Initial doubts about coaching program, commitment to listen, and immense benefits',
    },
    {
      id: 'client-h',
      name: 'Client H',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/6bbcf0efd4b6331dc336419197e346df.png',
      summary: 'Understanding triggers, building solid strategy, relapsing 1-2x/week to 4 months clean',
    },
    {
      id: 'client-i',
      name: 'Client I',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/e6c2daca996cbcaa13de8e8f8bb510fd.png',
      summary: 'Proud of uncovering reasons behind addiction and gaining hope',
    },
    {
      id: 'client-j',
      name: 'Client J',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/e54a605fbb4fb1ec32ab51973afae559.png',
      summary: '10 years addiction, tried 3 years solo recovery without success',
    },
    {
      id: 'client-k',
      name: 'Client K',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/9ec23291b2134301e08f76c2963046e3.png',
      summary: 'Equal partnership relationship, coach never made them feel bad, proud of recovery progress',
    },
    {
      id: 'client-l',
      name: 'Client L',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/a865dc18031f1e598e6d170e867b9369.png',
      summary: 'From inconsistent short-term sobriety to understanding acting-in process and long-term results',
    },
    {
      id: 'client-m',
      name: 'Client M',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/7644fc7190b3c9141c7a0954448e04b9.png',
      summary: '14 months sober, established routines, clear boundaries, better at handling setbacks, improved sabr',
    },
    {
      id: 'client-n',
      name: 'Client N',
      image: 'https://static.readdy.ai/image/8a86924c37578583a2eb4b2d060c5a4d/bfddb34dc0c2913b1f8116a66b95ba8c.png',
      summary: 'Grateful for sobriety, family support, and over 3 months clean with daily program commitment',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-teal-600 via-emerald-600 to-teal-700">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
          <nav className="text-sm text-teal-100 mb-6">
            <span>Home</span>
            <i className="ri-arrow-right-s-line mx-2"></i>
            <span>Testimonials</span>
          </nav>
          <h1 className="text-6xl md:text-7xl font-serif font-bold mb-6">
            Real Stories, Real Results
          </h1>
          <p className="text-xl text-teal-50 max-w-2xl mx-auto">
            Authentic conversations from Muslim men who've transformed their lives through our program
          </p>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block px-4 py-2 bg-teal-50 text-teal-700 rounded-full text-sm font-medium mb-4">
              Verified Client Messages
            </div>
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-6">
              What Our Clients Say
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              These are real WhatsApp conversations from real men who decided to take action and break free from addiction. Every message is authentic and unedited.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-100 hover:shadow-xl transition-shadow">
                <div className="p-4 bg-gradient-to-r from-teal-50 to-emerald-50 border-b border-gray-100">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center space-x-3">
                      <div className="w-10 h-10 flex items-center justify-center bg-teal-600 rounded-full">
                        <i className="ri-user-line text-white text-lg"></i>
                      </div>
                      <span className="font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <div className="flex items-center space-x-1 text-teal-600">
                      <i className="ri-checkbox-circle-fill"></i>
                      <span className="text-xs font-medium">Verified</span>
                    </div>
                  </div>
                </div>
                <div className="w-full h-[600px] bg-gray-50 p-4">
                  <img
                    src={testimonial.image}
                    alt={`${testimonial.name} testimonial`}
                    className="w-full h-full object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="text-center mt-16">
            <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
              These are real conversations from real men who decided to take action. Your story could be next.
            </p>
            <a
              href="https://calendly.com/coachabdurrahman1/why-your-still-relapsing"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-teal-600 text-white px-10 py-5 rounded-full text-lg font-bold hover:bg-teal-700 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
            >
              Start Your Transformation Today
            </a>
          </div>
        </div>
      </section>

      {/* Trust Indicators */}
      <section className="py-16 bg-gradient-to-br from-gray-50 to-slate-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">100% Confidential</h3>
              <p className="text-gray-600">
                Every conversation is private and secure. Your trust is our priority.
              </p>
            </div>

            <div>
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-user-heart-line text-3xl text-emerald-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">150+ Men Helped</h3>
              <p className="text-gray-600">
                Proven track record of helping Muslim men break free from addiction.
              </p>
            </div>

            <div>
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 rounded-full mx-auto mb-4">
                <i className="ri-time-line text-3xl text-amber-600"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2">6 Years Experience</h3>
              <p className="text-gray-600">
                Dedicated coaching with 2,000+ hours of 1-on-1 mentoring experience.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default TestimonialsPage;
